var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C16.0234 20 20.5 15.5234 20.5 10C20.5 4.47656 16.0234 0 10.5 0C4.97656 0 0.5 4.47656 0.5 10C0.5 15.5234 4.97656 20 10.5 20ZM10.5 5C11.0195 5 11.4375 5.41797 11.4375 5.9375V10.3125C11.4375 10.832 11.0195 11.25 10.5 11.25C9.98047 11.25 9.5625 10.832 9.5625 10.3125V5.9375C9.5625 5.41797 9.98047 5 10.5 5ZM11.75 13.75C11.75 14.4414 11.1914 15 10.5 15C9.80859 15 9.25 14.4414 9.25 13.75C9.25 13.0586 9.80859 12.5 10.5 12.5C11.1914 12.5 11.75 13.0586 11.75 13.75Z",
    fill: "#FF6262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.80c595a379b144c9eb6132191042566d.svg";
export { ForwardRef as ReactComponent };